import React, { useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import css from './Report.module.css'
import Excel from "../../../../assets/Icon/Excel";
import DateSelect from '../../../UI/Inputs/DateSelect';
 
  
const Report = ({ containerService, cargoService }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dates, setDates] = useState({});
    const [validationMessage, setValidationMessage] = useState("");  

    const openTableParams = () => {
        setIsModalOpen(true);
        setValidationMessage(""); 
    };

    const closeTableParams = () => {
        setIsModalOpen(false);
    };

    const report = () => {
        if (!dates.min || !dates.max) {  
            setValidationMessage("აირჩიეთ ორივე თარიღი"); 
            return;  
        }
        containerService.downloadReport(dates); 
    };

    const handleMin = (date) => {
        setDates({ ...dates, min: date ? date : "" });
    };

    const handleMax = (date) => {
        setDates({ ...dates, max: date ? date : "" });
    };

    return (
        <div>

            <span className={css.exelBtn} onClick={openTableParams}>
                <span className={css.icon} > <Excel /></span>
                <span className={css.text} >რეპორტი</span>
                
            </span> 
 
 

            <Modal size="small" isOpen={isModalOpen} onClose={closeTableParams}>
                <div className={css.modalHead}>
                    <h3>რეპორტი</h3>
                </div>

                <div className={css.row}>
                    <div className={css.col}>
                        <DateSelect
                            defDate={""}
                            onChange={handleMin}
                            placeholderText="დან"
                            popperClassName={css.dataContainer}
                            wrapperClassName={css.dataContainer}
                            className={css.input}
                            isClearable
                        />
                    </div>
                    <div className={css.col}>
                        <DateSelect
                            defDate={""}
                            onChange={handleMax}
                            placeholderText="მდე"
                            popperClassName={css.dataContainer}
                            wrapperClassName={css.dataContainer}
                            className={css.input}
                            isClearable
                        />
                    </div>
                </div>
                 
                
                {validationMessage && <div className={css.validationMessage}>{validationMessage}</div>} {/* Step 3: Display validation message */}

                <div className={css.reportButtonContainer}>
                    <button onClick={report} className={css.btnPrimary}>რეპორტის ჩამოწერა</button>
                </div>
            </Modal>
        </div>
    );
};

export default Report;
